import JobNotesCard, { JobNotesCardProps } from './JobNotesCard.container';

export type JobNotesCardType = JobNotesCardProps;

export default JobNotesCard;
